// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Button-module-button-L4Usa{display:inline-flex;text-decoration:none;cursor:pointer;color:var(--colors-text-text-primary);font-size:var(--size-text-small);line-height:var(--line-height-text-md);letter-spacing:var(--letter-spacing-none);gap:var(--spacing-5xs);background-color:rgba(0,0,0,0)}.Button-module-button-L4Usa:hover{color:var(--colors-text-text-tertiary)}", ""]);
// Exports
exports.locals = {
	"button": "Button-module-button-L4Usa"
};
module.exports = exports;
